export { default as List } from './List';
export { default as Detail } from './Detail';
